import React from 'react';
import PropTypes from 'prop-types';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            component: null,
        };

        return this;
    }

    componentDidMount() {
        if (!this.state.component && this.props.loader) {
            this.props.loader().then(component => {
                component = component.default || component;

                if (component) {
                    this.setState({component: component});
                }
            });
        }
    }

    render() {
        if (this.state.component) {
            let props = Object.assign({}, this.props);

            delete props.loader;
            return React.createElement(this.state.component, props, props.children);
        } else {
            return <div />;
        }
    }

    static propTypes = {
        loader: PropTypes.func.isRequired,
    };

    static displayName = 'AsyncModuleLoader';
}
